import React from 'react'

const Twitter = () => {
  return (
    <div className="text-6xl font-bold">
        Twitter
    </div>
  )
}

export default Twitter